import { API_ENDPOINT } from "@cede/utils";
import { apiHelper } from "@/utils/api";
import { useQuery } from "@tanstack/react-query";

type UseMarketRateParams = {
  exchangeId: string;
  pairSymbol: string;
};

// TODO: remove this hook - use usePublicMarketRate instead - return Decimal from the endpoint and parse it
export const useMarketRate = ({ exchangeId, pairSymbol }: UseMarketRateParams) => {
  const { data: marketRate, isLoading } = useQuery({
    queryKey: ["marketRate", exchangeId, pairSymbol],
    queryFn: () =>
      apiHelper.getOrThrow(API_ENDPOINT.HUB_TRADE_PUBLIC_MARKET_RATE, {
        queryParams: {
          pairSymbol,
          exchangeId,
        },
      }),
  });

  return {
    marketRate,
    isLoading,
  };
};
